import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InputNumberComponent } from './input-number.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [InputNumberComponent],
  exports: [
    InputNumberComponent
  ]
})
export class InputNumberModule { }
